(function () {

  function triggerDawnCart() {
    /* Dawn uses pubsub.js — publish the cart update event to trigger drawer refresh */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bb-variant-pills' });
    } else {
      /* Fallback: directly call open on cart-drawer element */
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        /* Force Dawn's cart drawer to re-render by dispatching its expected event */
        drawer.dispatchEvent(new CustomEvent('cart-update', { bubbles: true }));
        if (typeof drawer.renderContents === 'function') drawer.renderContents({});
        if (typeof drawer.open === 'function') drawer.open();
      }
    }
  }

  function updateCard(container) {
    var variantsRaw = container.querySelector('.bb-vp__variants-json');
    if (!variantsRaw) return;
    var variants   = JSON.parse(variantsRaw.textContent);
    var grindIndex = container.dataset.grindIndex !== 'nil' ? parseInt(container.dataset.grindIndex, 10) : null;
    var sizeIndex  = container.dataset.sizeIndex  !== 'nil' ? parseInt(container.dataset.sizeIndex,  10) : null;
    var hasGrind   = container.dataset.hasGrind === 'true';
    var hasSize    = container.dataset.hasSize  === 'true';
    var productUrl = container.dataset.productUrl;
    var availEl    = container.querySelector('.bb-vp__avail');
    var input      = container.querySelector('.bb-vp__variant-input');
    var atcBtn     = container.querySelector('.bb-vp__atc');

    var selectedGrind = hasGrind ? (container.querySelector('.bb-vp__pills[data-option="grind"] .bb-vp__pill--active') || {dataset:{}}).dataset.value : null;
    var selectedSize  = hasSize  ? (container.querySelector('.bb-vp__pills[data-option="size"] .bb-vp__pill--active') || {dataset:{}}).dataset.value : null;

    var variant = variants.find(function(v) {
      var gm = !hasGrind || (grindIndex !== null && v.options[grindIndex] === selectedGrind);
      var sm = !hasSize  || (sizeIndex  !== null && v.options[sizeIndex]  === selectedSize);
      return gm && sm;
    });

    if (!variant) {
      availEl.textContent = 'Unavailable';
      availEl.className = 'bb-vp__avail out';
      atcBtn.disabled = true;
      atcBtn.textContent = 'Unavailable';
      return;
    }

    input.value = variant.id;

    if (!variant.available) {
      availEl.textContent = 'Out of stock';
      availEl.className = 'bb-vp__avail out';
      atcBtn.disabled = true;
      atcBtn.textContent = 'Out of Stock';
    } else {
      availEl.textContent = '';
      availEl.className = 'bb-vp__avail';
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add to Cart';
    }

    var card = container.closest('.card-wrapper, .product-card-wrapper');
    if (card) {
      card.querySelectorAll('a[href]').forEach(function(a) {
        if (a.href.indexOf(productUrl.split('?')[0]) !== -1) {
          a.href = productUrl + '?variant=' + variant.id;
        }
      });
    }
  }

  function initContainer(container) {
    container.querySelectorAll('.bb-vp__pill').forEach(function(pill) {
      pill.addEventListener('click', function(e) {
        e.stopPropagation();
        var group = pill.closest('.bb-vp__pills');
        group.querySelectorAll('.bb-vp__pill').forEach(function(p) {
          p.classList.remove('bb-vp__pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('bb-vp__pill--active');
        pill.setAttribute('aria-pressed', 'true');
        container.querySelector('.bb-vp__atc-msg').textContent = '';
        updateCard(container);
      });
    });

    var form = container.querySelector('.bb-vp__form');
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var btn       = container.querySelector('.bb-vp__atc');
      var atcMsg    = container.querySelector('.bb-vp__atc-msg');
      var variantId = parseInt(container.querySelector('.bb-vp__variant-input').value, 10);
      var origText  = btn.textContent;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      var fd = new FormData();
fd.append('id', variantId);
fd.append('quantity', 1);
fd.append('sections', 'cart-drawer,cart-icon-bubble');
fd.append('sections_url', window.location.pathname);

fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
  method: 'POST',
  headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
  body: fd
})
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status) {
          btn.textContent = origText;
          btn.disabled = false;
          atcMsg.textContent = data.description || 'Error — try again.';
          atcMsg.className = 'bb-vp__atc-msg error';
        } else {
          btn.textContent = 'Added \u2713';

var cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
  cartDrawer.classList.remove('is-empty');
  var inner = cartDrawer.querySelector('.drawer__inner');
  if (inner) inner.classList.remove('is-empty');
  cartDrawer.renderContents({ id: variantId, sections: data.sections });
}

// Update cart bubble
if (data.sections && data.sections['cart-icon-bubble']) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
  var newBubble = doc.querySelector('.cart-count-bubble');
  var oldBubble = document.querySelector('.cart-count-bubble');
  if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
}

setTimeout(function() {
  btn.textContent = origText;
  btn.disabled = false;
}, 2000);
        }
      })
      .catch(function() {
        btn.textContent = origText;
        btn.disabled = false;
        atcMsg.textContent = 'Something went wrong.';
        atcMsg.className = 'bb-vp__atc-msg error';
      });
    });

    container.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    updateCard(container);
  }

  function initAll() {
    document.querySelectorAll('.bb-vp:not([data-init])').forEach(function(el) {
      el.dataset.init = '1';
      initContainer(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.MutationObserver) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      new MutationObserver(initAll).observe(grid, { childList: true, subtree: true });
    }
  }

})();
